module.exports = __webpack_public_path__ + "static/media/MAPA DE PROCESOS (1).b2fdab3d.pdf";